import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["error", "fieldType", "inputUse", "value", "disabled"];
import { DATE, DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import FilterOperatorErrorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorErrorType';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { getTransferableProps } from './filterInputProps';
import { fromSimpleDate, toSimpleDate } from 'customer-data-filters-ui/utils/momentSimpleDateConversion';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FilterOperatorDateInput extends Component {
  constructor(...args) {
    super(...args);
    this.handleChange = evt => {
      const {
        onChange,
        fieldType
      } = this.props;
      onChange(syntheticEvent(fromSimpleDate(fieldType, evt.target.value)));
    };
    this.handleOpenChange = evt => {
      const {
        onBlur
      } = this.props;
      if (!evt.target.value && onBlur) {
        onBlur();
      }
    };
  }
  render() {
    const _this$props = this.props,
      {
        error,
        fieldType,
        inputUse,
        value,
        disabled = false
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const isError = error.get('error');
    const errorMessage = error.get('message');
    const transferableProps = getTransferableProps(rest);
    const {
      ['data-selenium-test']: dataSeleniumTest
    } = transferableProps;
    // @ts-expect-error allows us to avoid spreading props to UIComponents
    const readOnly = transferableProps.readOnly;
    return /*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(UIDateInput, {
        "data-selenium-test": dataSeleniumTest,
        readOnly: readOnly,
        onChange: this.handleChange,
        onOpenChange: this.handleOpenChange,
        use: inputUse,
        value: toSimpleDate(fieldType, value),
        disabled: disabled
      })
    });
  }
}
FilterOperatorDateInput.propTypes = {
  error: FilterOperatorErrorType.isRequired,
  fieldType: PropTypes.oneOf([DATE, DATE_TIME]).isRequired,
  inputUse: PropTypes.oneOf(['on-dark']),
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};